import * as t from 'runtypes';
import { FetcherContext } from '@rogu/fetch';

import {
  FileUploaderResponse,
  FileUploaderRequest,
  BucketData,
} from './fileUploaderEntity';

import fetcher from '@/shared/fetcher';

type Err<Tag, Value> = {
  readonly _tag: Tag;
  readonly value: Value;
};

type FileUploaderError = Err<
  'DECODE_ERROR' | 'UNKNOWN_ERROR' | 'INTERNAL_ERROR' | 'BAD_REQUEST',
  Record<string, unknown>
>;

const FileUploaderResponseSchema = t.Record({
  s3URL: t.String,
});

function postFileUploader(
  payload: FileUploaderRequest,
  fetcherContext?: FetcherContext,
) {
  const formData = new FormData();
  formData.set('file', payload.file);
  formData.set('presetID', payload.presetID);
  payload.contentType && formData.set('contentType', payload.contentType);
  payload.path && formData.set('path', payload.path);

  return new Promise<FileUploaderResponse>((resolve, reject) =>
    fetcher({
      formData: formData,
      url: '/file-uploader/upload',
      method: 'post',
      withAuth: true,
      ...fetcherContext,
    })
      .then((data) => {
        return FileUploaderResponseSchema.check(data);
      })
      .then((dataOk) => {
        resolve(dataOk);
      })
      .catch((error) => {
        if (error.name && error.name === 'ValidationError') {
          return reject({
            _tag: 'DECODE_ERROR',
            value: { message: error.message },
          });
        } else if (error.errorCode) {
          switch (error.errorCode) {
            case 91101:
              return reject({
                _tag: 'INTERNAL_ERROR',
                value: error,
              });
            case 91102:
              return reject({
                _tag: 'BAD_REQUEST',
                value: error,
              });
          }
        }
        return reject({ _tag: 'UNKNOWN_ERROR', value: error });
      }),
  );
}

function fileUploaderConfig() {
  return new Promise<Array<BucketData> | undefined>((resolve, reject) =>
    fetch('https://cdn-web.ruangguru.com/file-uploader-ui/config/config.json')
      .then((res) => res.json())
      .then((dataOk) => {
        return resolve(dataOk as Array<BucketData>);
      })
      .catch((error) => {
        if (error.name && error.name === 'ValidationError') {
          return reject({
            _tag: 'DECODE_ERROR',
            value: { message: error.message },
          });
        } else if (error.errorCode) {
          switch (error.errorCode) {
            case 91101:
              return reject({
                _tag: 'INTERNAL_ERROR',
                value: error,
              });
            case 91102:
              return reject({
                _tag: 'BAD_REQUEST',
                value: error,
              });
          }
        }
        return reject({ _tag: 'UNKNOWN_ERROR', value: error });
      }),
  );
}

export type { FileUploaderError };
export { postFileUploader, fileUploaderConfig };
